<template>
  <div class="pa-10">
    <title-page icon="mdi-shape">{{ $t('organization.sub-perimeter.search') || $t('organization.sub-perimeter.add') }}</title-page>

    <v-row v-if="currentUser.permissions.includes('ORGANIZATION_WRITE')">
      <v-col class="text-right">
        <v-btn class="mr-2" :to="{name: 'organization-perimeter'}" small>
          <v-icon left>mdi-domain</v-icon>
          {{ $t('organization.perimeter.search') }}
        </v-btn>
        <v-btn :to="{name: 'organization-sub-perimeter.add'}" small class="ml-3">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('organization.sub-perimeter.add') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <search-field :placeholder="$t('search')" :search.sync="search" clearable />
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :options.sync="options"
          :server-items-length="total"
        >
          <template #item.name="{value}">
            {{ localizedString(value) }}
          </template>
          <template #item.perimeters="{ value }">
            <div>
              <template v-if="value && value.length">
                <v-chip
                  v-for="p in value"
                  :key="p.id"
                  small
                  class="ma-1"
                  outlined
                >
                  {{ localizedString(p.name) || '-'  }}
                </v-chip>
              </template>
              <template v-else>-</template>
            </div>
          </template>
          <template #item.options="{item}">
            <v-btn icon :to="{name: 'organization-sub-perimeter.edit', params: {id: item.id}}"><v-icon>mdi-pencil</v-icon></v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OrganizationPerimeterRepository from "@repository/OrganizationPerimeterRepository";

export default {
  data() {
    return {
      loading: false,
      search: null,
      items: [],
      total: 0,
      options: {page:1, itemsPerPage:10, sortBy:['name'], sortDesc:[false]},
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t('code'), value: 'code'},
        {text: this.$t('name'), value: 'name'},
        {text: this.$tc('organization.perimeter.perimeter', 2), value: 'perimeters'},
        {text: '', value: 'options', width: 140},
      ]
    }
  },
  watch: {
    search() { this.triggerSearch() },
    options: { deep: true, handler() { this.searchData() } }
  },
  mounted() {
    if(!this.currentUser.permissions.includes('ORGANIZATION_WRITE')) {
      this.$router.replace({name: 'dashboard'})
      return
    }
  },
  methods: {
    triggerSearch() {
      if(this.options.page > 1) { this.options.page = 1 } else { this.searchData() }
    },
    searchData() {
      if(!this.options) return
      this.loading = true
      const query = this.search
      const offset = this.options.itemsPerPage * this.options.page - this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : 'name'
      const orderDirection = this.options.sortDesc.length > 0 && this.options.sortDesc[0] ? 'desc' : 'asc'

      OrganizationPerimeterRepository.searchSubPerimeters(query, offset, limit, orderBy, orderDirection)
        .then(result => {
          this.total = result.total
          this.items = result.items || []
          this.loading = false
        }).catch(err => {
          this.notifyError(err)
          this.loading = false
        })
    }
  }
}
</script>
